<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filtersRichtext, textLenHandler, imgPathFn } from '@/utils/common'

export default {
  name: 'Comp50',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, filtersRichtext, textLenHandler, imgPathFn,
    currentData(i) {
      let dataObj = {}
      this.moduleOption.list.forEach((item, idx) => {
        if (i === idx) dataObj = item
      })
      return dataObj
    }
  }
}
</script>

<template>
  <div class="modules-id-50">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div class="comp-transverse-2 modules-id-50-content">
      <!-- v-for="(v, i) in moduleOption.list.slice(0, 7)" -->
      <div
        v-for="(v, i) in 7"
        :key="`modules-id-50-item-${v}`"
        class="item"
      >
        <img
          class="item-img"
          :class="`item-img-${v}`"
          :src="imgPathFn(currentData(i).photo)"
          alt="photo"
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-50-content {
  width: 650px;
  height: 320px;
  background: url('~imgs/modules/comp50-bg.webp') no-repeat center;
  background-size: 100% 100%;
  position: relative;
  .item {
    padding: 0;
    .item-img {
      border-radius: 50%;
      object-fit: cover;
      position: absolute;
    }
    .item-img-1 {
      border: 7px solid #FDEB5A;
      width: 230px;
      height: 230px;
      top: 46px;
      left: 16px;
    }
    .item-img-2 {
      border: 7px solid #F52A2A;
      width: 128px;
      height: 128px;
      top: 86px;
      left: 290px;
      z-index: 10;
    }
    .item-img-3 {
      border: 7px solid #F5F051;
      width: 80px;
      height: 80px;
      top: 36px;
      left: 360px;
      z-index: 6;
    }
    .item-img-4 {
      border: 7px solid #E56C25;
      width: 100px;
      height: 100px;
      top: 96px;
      left: 400px;
      z-index: 7;
    }
    .item-img-5 {
      border: 7px solid #5A9CF6;
      width: 100px;
      height: 100px;
      top: 168px;
      left: 366px;
      z-index: 8;
    }
    .item-img-6 {
      border: 7px solid #EE9BFA;
      width: 88px;
      height: 88px;
      top: 52px;
      left: 521px;
    }
    .item-img-7 {
      border: 7px solid #FB6481;
      width: 77px;
      height: 77px;
      top: 194px;
      left: 510px;
    }
  }
}
</style>
